import Common from '../../../../Common';

export interface PbxDadFlowDestinationsObject {
	[key: id]: PbxDadFlowDestinationsItem
}

export interface PbxDadFlowDestinationsItem {
	name: string
	id: id
	description: string
	pbx_destination_id: id
	pbx_dad_flow_ids: id[]
}

export interface PbxDadFlowDestinations {
	Select: any
	announcement: PbxDadFlowDestinationsObject
	callback: PbxDadFlowDestinationsObject
	callbackrecording: PbxDadFlowDestinationsObject
	calleridroute: PbxDadFlowDestinationsObject
	cfc: PbxDadFlowDestinationsObject
	destination: PbxDadFlowDestinationsObject
	ivr: PbxDadFlowDestinationsObject
	miscapp: PbxDadFlowDestinationsObject
	num2mail: PbxDadFlowDestinationsObject
	page: PbxDadFlowDestinationsObject
	queue: PbxDadFlowDestinationsObject
	queuecallerpriority: PbxDadFlowDestinationsObject
	queueskill: PbxDadFlowDestinationsObject
	ringgroup: PbxDadFlowDestinationsObject
	setcid: PbxDadFlowDestinationsObject
	setlanguage: PbxDadFlowDestinationsObject
	tbr: PbxDadFlowDestinationsObject
	blackhole: PbxDadFlowDestinationsObject
	user: PbxDadFlowDestinationsObject
	voicemail: PbxDadFlowDestinationsObject
	[key: string]: PbxDadFlowDestinationsObject
}

const Destination = class extends Common {
	browse = (companyId: id, flowId: id): CustomResponse<PbxDadFlowDestinations> =>
		this.get(`/company/${companyId}/pbxdad/flow/${flowId}/destination`)

	flow = (companyId: id, flowId: id, destinationId: id) =>
		this.get(`/company/${companyId}/pbxdad/flow/${flowId}/destination/${destinationId}/flow`)
}

export default Destination
